var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1065,
    height: 300,
    viewBox: "0 0 1065 300",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-752.36216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3337",
    transform: "translate(-353.3275,478.58303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3339"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3341",
    points: "1065.83,566.929 1102.68,388.346 1116.71,566.929 1196.223,566.929 1159.373,283.464 1074.333,283.464 1034.646,453.542 994.964,283.464 909.924,283.464 873.072,566.929 952.443,566.929 966.617,388.346 1003.468,566.929",
    style: {
      fill: "#0f238c"
    }
  }), "\n\n```\n    ", /*#__PURE__*/React.createElement("g", {
    id: "g3343"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3345",
    points: "1312.442,283.464 1235.907,283.464 1235.907,566.929 1417.324,566.929 1417.324,507.401 1312.442,507.401",
    style: {
      fill: "#0f238c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3349",
    d: "m 535.749,283.464 -96.379,0 -85.039,283.465 85.04,0 11.338,-51.023 73.701,0 11.339,51.023 85.04,0 -85.04,-283.465 z m -48.189,62.362 25.512,116.22 -51.024,0.001 25.512,-116.221 z",
    style: {
      fill: "#0f238c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3353",
    d: "m 824.881,362.835 c -70.432,-61.604 -180.339,-36.558 -181.417,19.843 -15.981,-104.645 110.563,-126.492 181.41,-93.544 1.262,16.802 2.527,34.892 0.007,73.701 z",
    style: {
      fill: "#0f238c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3355",
    d: "m 766.445,396.213 c -17.745,-6.926 -43.562,-13.227 -43.599,-33.403 -0.015,-8.241 3.375,-17.189 19.83,-22.651 -56.693,5.669 -75.599,74.633 -12.896,108.91 10.928,5.974 29.904,12.311 29.904,32.82 0,23.957 -26.32,32.617 -43.634,32.251 -28.761,-0.605 -51.885,-10.652 -78.256,-29.417 l 0,68.032 c 31.207,13.434 82.039,28.928 132.996,13.256 41.183,-12.666 76.768,-47.236 76.768,-84.123 0.002,-60.022 -52.091,-74.346 -81.113,-85.675 z",
    style: {
      fill: "#0f238c"
    }
  }))), "\n```\n\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsml);
export default __webpack_public_path__ + "static/media/asml.6f22f97f93fac87010f19f973c699c4f.svg";
export { ForwardRef as ReactComponent };